/**
 * Types of actions provided by office.com
 */
export var OfficeActionType;
(function (OfficeActionType) {
    /**
     * Open a piece of content in an M365 app in another window
     */
    OfficeActionType["contentApp"] = "contentApp";
    /**
     * Open a piece of content in an M365 app in existing context (ie modal/sidecar)
     */
    OfficeActionType["contentAppInContext"] = "contentAppInContext";
    /**
     * Copy a link to ODSP content via its Share URL in context (with a popup)
     */
    OfficeActionType["contentCopyInContext"] = "contentCopyInContext";
    /**
     * Download a web-hosted piece of content via URL
     */
    OfficeActionType["contentDownload"] = "contentDownload";
    /**
     * Open the remote location of a piece of content (via web browser)
     */
    OfficeActionType["contentLocation"] = "contentLocation";
    /**
     * Open the local location of a piece of content (in Windows explorer)
     */
    OfficeActionType["contentLocationLocal"] = "contentLocationLocal";
    /**
     * Open content natively on mobile or tablet platforms
     */
    OfficeActionType["contentNative"] = "contentNative";
    /**
     * Opens a piece of content inline in the unified host if WXP, or launches a URL if not
     * This action is the same as if a user clicked on a file in a content list/grid/card
     */
    OfficeActionType["contentOpen"] = "contentOpen";
    /**
     * Share ODSP content via its Share URL in context (with a popup)
     */
    OfficeActionType["contentShareInContext"] = "contentShareInContext";
    /**
     * Open a piece of content in a new browser tab via URL
     */
    OfficeActionType["contentUrl"] = "contentUrl";
    /**
     * Copy some data to the user's clipboard
     */
    OfficeActionType["copyToClipboard"] = "copyToClipboard";
    /**
     * Create a To Do item with a link to a piece of content
     */
    OfficeActionType["createTodo"] = "createTodo";
    /**
     * Navigate to an M365 app
     */
    OfficeActionType["deepLinkToApp"] = "deepLinkToApp";
    /**
     * Navigate to an M365 app in a new window
     */
    OfficeActionType["deepLinkToAppExternal"] = "deepLinkToAppExternal";
    /**
     * Sends file to recycle bin
     */
    OfficeActionType["delete"] = "delete";
    /**
     * Restores an item from the recycle bin
     */
    OfficeActionType["deleteRestore"] = "deleteRestore";
    /**
     * Open an external URL in browser
     */
    OfficeActionType["externalUrl"] = "externalUrl";
    /**
     * Open an external URL in context on the current route/page
     */
    OfficeActionType["externalUrlInContext"] = "externalUrlInContext";
    /**
     * Open a link (.url file) by launching the URL
     */
    OfficeActionType["linkContentOpen"] = "linkContentOpen";
    /**
     * Convert's an ODSP drive item to a supported format and uploads the resulting file to the root of the current user's OneDrive for Business
     *
     * As implemented, only converting to PDF is supported for xlsx, docx, and pptx.
     * However, converting pptx to jpg is also a possilibity. For more information, see docs:
     * {@link https://docs.microsoft.com/en-us/graph/api/driveitem-get-content-format?view=graph-rest-beta&tabs=http#query-parameters}
     */
    OfficeActionType["convertDriveItem"] = "convertDriveItem";
    /**
     * Open Teams share endpoint in in-context dialog to share content url
     */
    OfficeActionType["openShareToTeams"] = "openShareToTeams";
    /**
     * Open hub task module
     */
    OfficeActionType["openTaskModule"] = "openTaskModule";
    /**
     * Open an Outlook calendar compose deeplink with a link to a piece of content
     */
    OfficeActionType["schedule"] = "schedule";
    /**
     * Actions service is open for extensibility. Until we get to a point where all actions
     * are registered and handled by the actions service, it will still be advantageous for all actions to get
     * executed, logged and notified in the same way from wherever they are in the application
     */
    OfficeActionType["unregistered"] = "unregistered";
})(OfficeActionType || (OfficeActionType = {}));
//# sourceMappingURL=officeActionDefinition.js.map